import { useEffect, useState } from 'react'; 
import { LineChart } from '@mui/x-charts/LineChart';
import moneyFormat from '../functions/moneyFormat';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import Skeleton from '@mui/material/Skeleton';
import { blueberryTwilightPalette } from '@mui/x-charts/colorPalettes';

const SpendLineChart = ({ data, keys, xAxisProp, yAxisProp, isLoading, colors }) => {
    const [series, setSeries] = useState([{
        data: [1],
        label: 'Loading', 
    }]); 
    const [dataSet, setDataSet] = useState([]); 
    const [xAxis, setXAxis] = useState([0]); 
    const [yAxis, setYAxis] = useState([{
        id: 'default', scaleType: 'linear', 
    }]);  
    const [colorPallete, setColorPallete] = useState(); 

    // useEffect to run on yAxisProp change 
    useEffect(() => {
        console.log(yAxisProp); 
        if (yAxisProp) {
            let graphAxis = yAxisProp; 
            // add value format to yAxis
            for (let i = 0; i < graphAxis.length; i++) {
                // set format for scale
                if (graphAxis[i]['id'] == 'spend') {
                  graphAxis[i]['valueFormatter'] = (value) => { 
                    return '$' + (value/1000000).toString() + 'M'
                  }; 
                } 
                else if (graphAxis[i]['id'] == 'rebate') {
                  graphAxis[i]['valueFormatter'] = (value) => { 
                    return '$' + (value/1000).toString() + 'K'
                  }; 
                } 
            }
            // set yAxis
            setYAxis(yAxis => yAxis = graphAxis); 
        }
    }, [yAxisProp]);

    // useEffect to run on xAxisProp change 
    useEffect(() => {
        if (xAxisProp){ 
            setXAxis(xAxis => xAxis = xAxisProp); 
        }
    }, [xAxisProp]); 

    // useEffect to run on data change 
    useEffect(() => {
        if ( data ) { 
            // set data set
            setDataSet(dataSet => dataSet = data); 
        }
    }, [data]); 

    // useEffect to run on keys change 
    useEffect(() => {
        if (keys) {
            let dataKeys = keys 
            for (let i = 0; i < dataKeys.length; i++) {
                dataKeys[i]['valueFormatter'] = (value) =>{ 
                    return moneyFormat(value);
                };
            }
            // set series
            setSeries(series => series = keys); 
        }
    }, [keys]); 

    // useEffect to run on colors change 
    useEffect(() => {
        if (colors && colors.length > 0){
            setColorPallete(colorPallete => colorPallete = colors); 
        }
        else {
            setColorPallete(colorPallete => colorPallete = blueberryTwilightPalette); 
        }
    }, [colors]); 
 
    return(
        <>
            {isLoading ? 
            <>
                {/* <LineChart
                    loading
                    slotProps={{
                      noDataOverlay: { message: 'Loading Data....' },
                    }}
                    series={[]}
                    height={375}
                /> */}
                <Skeleton variant="rounded" height={335} />
            </>
            :<LineChart
                xAxis={[{ data: xAxis , scaleType: 'band', dataKey: 'xAxis' }]}
                yAxis={yAxis}
                series={series}
                dataset={dataSet}
                // width={1100}
                height={375}
                colors={colorPallete}
                margin={{ left: 100 }}
                sx={{
                    [`.${axisClasses.left} .${axisClasses.label}`]: {
                      // Move the y-axis label with CSS
                      transform: 'translateX(-28px)',
                    },
                    [`.${axisClasses.right} .${axisClasses.label}`]: {
                      // Move the y-axis label with CSS
                      transform: 'translateX(17px)',
                    },
                    width: '90%'
                  }}
            />}
        </>
    ); 
}

export default SpendLineChart;